export const shuffleArray = (array) => {
	for (let i = array.length - 1; i > 0; i--) {
		let j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
};

export const generateRandomIndexesOfArray = (array, limit) => {
	let randomArray = [];
	let randomIndex = null;

	//  set question number indexes
	for (let i = 0; i < limit; ) {
		randomIndex = Math.floor(Math.random() * (array.length - 1));

		if (!randomArray.includes(randomIndex)) {
			randomArray.push(randomIndex);
			i++;
		}
	}

	return randomArray;
};

export const convertBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const fileReader = new FileReader();
		fileReader.readAsDataURL(file);

		fileReader.onload = () => {
			resolve(fileReader.result);
		};

		fileReader.onerror = (error) => {
			reject(error);
		};
	});
};

export const findInObjectArrayByMatchingProperties = (array, objectItems) => {
	return array.filter(function (entry) {
		return Object.keys(objectItems).every(function (index) {
			return entry[index] === objectItems[index];
		});
	});
};

export const removeItemFromObjectArrayByMatchingProperties = (array, objectItems) => {
	const itemIndex = array.findIndex(function (entry) {
		return Object.keys(objectItems).every(function (index) {
			return entry[index] === objectItems[index];
		});
	});

	array.splice(itemIndex, 1);

	return array;
};

export const replaceItemInObjectArrayByMatchingProperties = (array, objectItems, formData) => {
	const itemIndex = array.findIndex(function (entry) {
		return Object.keys(objectItems).every(function (index) {
			return entry[index] === objectItems[index];
		});
	});

	array[itemIndex] = formData;

	return array;
};
